import { render, staticRenderFns } from "./PayslipFields.vue?vue&type=template&id=4987077b&scoped=true"
import script from "./PayslipFields.vue?vue&type=script&lang=js"
export * from "./PayslipFields.vue?vue&type=script&lang=js"
import style0 from "./PayslipFields.vue?vue&type=style&index=0&id=4987077b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4987077b",
  null
  
)

export default component.exports